export const getSuffix = value => {
  if(value === 0) return
  if(value < 1000) return ''
  if(value < 1000000) return ' K'
  if(value < 1000000000) return ' M'
  return ' B'
}